<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'HubEntrepriseFonctionnement'
});
</script>
<template>
  <ka-container
    code="comment-ca-marche-entreprises"
    :data="page.$info.commentCaMarcheEntreprises">
    <!-- Conteneur -->
    <ka-container code="conteneur">
      <!-- Conteneur 1 -->
      <ka-container code="conteneur-1">
        <!-- Conteneur 1 -->
        <ka-container code="container-1">
          <!-- Conteneur 2 -->
          <ka-container code="conteneur-2">
            <ka-text code="fonctionnement-des">
              <h1 v-html="t('commentCaMarcheEntreprises.conteneur.conteneur1.container1.conteneur2.fonctionnementDes.value', `Fonctionnement des formations Matchers`)" />
            </ka-text>
            <ka-text code="mettez-en-place-des">
              <span v-html="t('commentCaMarcheEntreprises.conteneur.conteneur1.container1.conteneur2.mettezEnPlaceDes.value', `Mettez en place des formations personnalisées et productives pour vos équipes. Savourez la pédagogie Matchers, on s’occupe de TOUT le reste !`)" />
            </ka-text>
            <!-- Conteneur -->
            <ka-container code="container-2">
              <!-- Conteneur 2 -->
              <ka-container code="container-3">
                <ka-icon
                  code="icone"
                  value="i-fa-solid:search" />
                <ka-text code="une-pedagogie-basee">
                  <span v-html="t('commentCaMarcheEntreprises.conteneur.conteneur1.container1.conteneur2.container2.container3.unePedagogieBasee.value', `Une pédagogie basée sur vos besoins projets.`)" />
                </ka-text>
              </ka-container>
              <!-- Conteneur 2 -->
              <ka-container code="container-4">
                <ka-icon
                  code="icon-1"
                  value="i-fa-solid:chart-line" />
                <ka-text code="un-suivi-administratif">
                  <span v-html="t('commentCaMarcheEntreprises.conteneur.conteneur1.container1.conteneur2.container2.container4.unSuiviAdministratif.value', `Un suivi administratif et budgétaire gratuit.`)" />
                </ka-text>
              </ka-container>
              <!-- Conteneur 2 -->
              <ka-container code="container-5">
                <ka-icon
                  code="icon-2"
                  value="i-fa-solid:check-double" />
                <ka-text code="des-formations-sur-mesure">
                  <span v-html="t('commentCaMarcheEntreprises.conteneur.conteneur1.container1.conteneur2.container2.container5.desFormationsSurMesure.value', `Des formations sur-mesure accessible aux TPE/PME.`)" />
                </ka-text>
              </ka-container>
              <!-- Conteneur 2 -->
              <ka-container code="container-6">
                <ka-icon
                  code="icon-3"
                  value="i-fa-solid:hands-helping" />
                <ka-text code="des-experts-qui-matchent">
                  <span v-html="t('commentCaMarcheEntreprises.conteneur.conteneur1.container1.conteneur2.container2.container6.desExpertsQuiMatchent.value', `Des experts qui “matchent” avec vos projets.`)" />
                </ka-text>
              </ka-container>
            </ka-container>
            <ka-button
              code="rechercher-une-formation"
              :options="{
                ripple: true,
                href: { name: `Formations` },
                click: page.rechercherUneFormationClick
              }">
              <span v-html="t('commentCaMarcheEntreprises.conteneur.conteneur1.container1.conteneur2.rechercherUneFormation.value', `Rechercher une formation`)" />
            </ka-button>
          </ka-container>
        </ka-container>
      </ka-container>
      <!-- Conteneur 1 -->
      <ka-container
        code="container-7"
        :xs="{ hidden: null }">
        <!-- Conteneur 1 -->
        <ka-container code="container-8">
          <ka-image
            code="image"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              imgFit: `cover`,
              alt: `De la définition des besoins au suivi de la formation, découvrez tout le fonctionnement de l'accompagnement Matchers !`
            }"
            :xs="{ hidden: null }"
            value="https://ucarecdn.com/fee38987-b8b0-4541-b70e-665305b9a75a/" />
        </ka-container>
      </ka-container>
    </ka-container>
    <!-- Comment ça marche -->
    <ka-container code="comment-ca-marche">
      <ka-text code="mise-en-place-dune">
        <h2 v-html="t('commentCaMarcheEntreprises.commentCaMarche.miseEnPlaceDune.value', `Mise en place d'une formation Matchers`)" />
      </ka-text>
      <ka-text code="la-personnalisation">
        <span v-html="t('commentCaMarcheEntreprises.commentCaMarche.laPersonnalisation.value', `La personnalisation au cœur de notre accompagnement. 🚀`)" />
      </ka-text>
    </ka-container>
    <!-- Questions déroulent -->
    <ka-container code="questions-deroulent">
      <!-- Conteneur question -->
      <ka-container code="conteneur-question">
        <!-- Deroulent -->
        <ka-container
          code="deroulent"
          :options="{
            click: page.deroulentClick,
            $state: { selected: $isEqual(page.$elements['question-1']?.style.hidden, page.$constants.question1Hidden) }
          }"
          :selected="{ click: page.deroulentClickWhenSelected }">
          <!-- placement -->
          <ka-container code="placement">
            <ka-icon
              code="icon-4"
              value="i-fa-solid:scroll" />
            <ka-text code="definissez-votre-besoin">
              <h3 v-html="t('commentCaMarcheEntreprises.questionsDeroulent.conteneurQuestion.deroulent.placement.definissezVotreBesoin.value', `Définissez votre besoin`)" />
            </ka-text>
          </ka-container>
          <ka-icon
            code="icone-developper-1"
            :options="{ $inheritState: { selected: true } }"
            value="i-fa-solid:angle-down" />
        </ka-container>
        <!-- Question 1 -->
        <ka-container
          code="question-1"
          :options="{ hidden: null }">
          <ka-text code="que-recherchez-vous">
            <span v-html="t('commentCaMarcheEntreprises.questionsDeroulent.conteneurQuestion.question1.queRecherchezVous.value', `Que recherchez-vous ? Approfondir la maîtrise d’un outil ou d’une technologie ? Atteindre des objectifs qui stagnent depuis des mois ? Mettre un coup d’accélérateur sur un projet ? Décrivez-nous votre besoin et Matchers vous présentera le(s) expert(s) pour y répondre. <br> <br>Si vous souhaitez être accompagné dans la définition ou la priorisation de vos objectifs n'hésitez pas à faire appel à l’équipe Matchers. C’est gratuit, sans engagement, plutôt rapide (15min sauf si vous êtes très très très bavard.e)<span style='font-size:11px;'>.</span>`)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Conteneur question -->
      <ka-container code="container-9">
        <!-- Deroulent -->
        <ka-container
          code="container-10"
          :options="{
            click: page.container10Click,
            $state: { selected: $isEqual(page.$elements['question-3']?.style.hidden, page.$constants.question3Hidden) }
          }"
          :selected="{ click: page.container10ClickWhenSelected }">
          <!-- placement -->
          <ka-container code="container-11">
            <ka-icon
              code="icon-5"
              value="i-fa-solid:hands-helping" />
            <ka-text code="matchez-avec-lexpert">
              <h3 v-html="t('commentCaMarcheEntreprises.questionsDeroulent.container9.container10.container11.matchezAvecLexpert.value', `Matchez avec l’expert idéal `)" />
            </ka-text>
          </ka-container>
          <ka-icon
            code="icone-developper-2"
            :options="{ $inheritState: { selected: true } }"
            value="i-fa-solid:angle-down" />
        </ka-container>
        <!-- Question 3 -->
        <ka-container
          code="question-3"
          :options="{
            animationIn: `fadeIn`,
            hidden: null
          }">
          <ka-text code="abracadabra-lexpert">
            <span v-html="t('commentCaMarcheEntreprises.questionsDeroulent.container9.question3.abracadabraLexpert.value', `Abracadabra l’expert qu’il vous fallait vous est présenté ! Il a toutes les compétences que vous recherchez. Dans 80 % des cas, en plus d’avoir l’expertise métier, les experts qui vous sont présentés ont également une connaissance de votre secteur d’activité ! <br> <br>Pour que cette collaboration soit un succès, Matchers organise un rendez-vous découverte pour que vous puissiez échanger au cours d’une visio de 30 min directement avec l’expert. Cet échange lui permettra de bien cerner votre besoin et de vous exposer son parcours et ses réalisations. Le second critère à prendre en compte : le feeling. Votre formation va durer plusieurs heures et il est essentiel que le courant passe pour rendre votre collaboration plus agréable et plus efficace. À l’issue de cette rencontre vous validerez votre intérêt et votre envie de travailler avec cet expert.`)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Conteneur question -->
      <ka-container code="container-12">
        <!-- Deroulent -->
        <ka-container
          code="container-13"
          :options="{
            click: page.container13Click,
            $state: { selected: $isEqual(page.$elements['question-2']?.style.hidden, page.$constants.question2Hidden) }
          }"
          :selected="{ click: page.container13ClickWhenSelected }">
          <!-- placement -->
          <ka-container code="container-14">
            <ka-icon
              code="icon-6"
              value="i-fa-solid:signal" />
            <ka-text code="matchers-se-charge">
              <h3 v-html="t('commentCaMarcheEntreprises.questionsDeroulent.container12.container13.container14.matchersSeCharge.value', `Matchers se charge du financement`)" />
            </ka-text>
          </ka-container>
          <ka-icon
            code="icone-developper-4"
            :options="{ $inheritState: { selected: true } }"
            value="i-fa-solid:angle-down" />
        </ka-container>
        <!-- Question 2 -->
        <ka-container
          code="question-2"
          :options="{
            animationIn: `fadeIn`,
            hidden: null
          }">
          <ka-text code="et-tout-ca-sans-douleur">
            <span v-html="t('commentCaMarcheEntreprises.questionsDeroulent.container12.question2.etToutCaSansDouleur.value', `Et tout ça sans douleur (parce que oui, ça peut faire mal) ni administrative ni financière. Matchers se charge de vous trouver le dispositif de financement le plus avantageux pour votre structure. Mais ça ne s’arrête pas là ! Nous nous occupons de toutes les démarches administratives. On aime pas trop ça mais on sait très bien le faire. Merci le mandat de gestion, adios l’administration.`)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Conteneur question -->
      <ka-container code="container-15">
        <!-- Deroulent -->
        <ka-container
          code="container-16"
          :options="{
            click: page.container16Click,
            $state: { selected: $isEqual(page.$elements['question-4']?.style.hidden, page.$constants.question4Hidden) }
          }"
          :selected="{ click: page.container16ClickWhenSelected }">
          <!-- placement -->
          <ka-container code="container-17">
            <ka-icon
              code="icon-7"
              value="i-fa-solid:list-ul" />
            <ka-text code="construction-de-votre">
              <h3 v-html="t('commentCaMarcheEntreprises.questionsDeroulent.container15.container16.container17.constructionDeVotre.value', `Construction de votre programme sur-mesure`)" />
            </ka-text>
          </ka-container>
          <ka-icon
            code="icone-developper-3"
            :options="{ $inheritState: { selected: true } }"
            value="i-fa-solid:angle-down" />
        </ka-container>
        <!-- Question 4 -->
        <ka-container
          code="question-4"
          :options="{
            animationIn: `fadeIn`,
            hidden: null
          }">
          <ka-text code="lexpert-matchers-realise">
            <span v-html="t('commentCaMarcheEntreprises.questionsDeroulent.container15.question4.lexpertMatchersRealise.value', `L'expert Matchers réalise puis vous présente un programme de formation individualisé selon VOS objectifs. Ce programme de formation sera le fil rouge de votre accompagnement. Bien évidemment les aléas de l’entreprise et de vos projets pourront entraîner des modifications au cours de la formation. <br> <br>Il se pourrait qu’une partie prenne plus de temps qu’une autre par exemple. Il s’agit donc d’une feuille de route malléable et non d’un programme rigide. Il doit rester cohérent par rapport aux expertises sur lesquelles vous souhaitez monter en compétence et peut donc s’adapter aux différentes situations que vous serez amenées à rencontrer durant la formation.`)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Conteneur question -->
      <ka-container code="container-18">
        <!-- Deroulent -->
        <ka-container
          code="container-19"
          :options="{
            click: page.container19Click,
            $state: { selected: $isEqual(page.$elements['question-5']?.style.hidden, page.$constants.question5Hidden) }
          }"
          :selected="{ click: page.container19ClickWhenSelected }">
          <!-- placement -->
          <ka-container code="container-20">
            <ka-icon
              code="icon-8"
              value="i-fa-solid:check-circle" />
            <ka-text code="validation-du-financement">
              <h3 v-html="t('commentCaMarcheEntreprises.questionsDeroulent.container18.container19.container20.validationDuFinancement.value', `Validation du financement`)" />
            </ka-text>
          </ka-container>
          <ka-icon
            code="icone-developper-5"
            :options="{ $inheritState: { selected: true } }"
            value="i-fa-solid:angle-down" />
        </ka-container>
        <!-- Question 5 -->
        <ka-container
          code="question-5"
          :options="{
            animationIn: `fadeIn`,
            hidden: null
          }">
          <ka-text code="matchers-a-bien-recolte">
            <span v-html="t('commentCaMarcheEntreprises.questionsDeroulent.container18.question5.matchersABienRecolte.value', `Matchers a bien récolté vos informations et déposé votre dossier auprès de votre OPCO. Comme par magie après quelques semaines de délai (environ 4) un budget apparaît à l’horizon. Ce budget va permettre de financer tout le service Matchers ainsi que l’intervention de notre expert. Pas un centime n’est sorti de votre poche (à moins bien sûr qu’elle soit trouée). Tout est réglé, la formation peut commencer 🚀`)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Conteneur question -->
      <ka-container code="container-21">
        <!-- Deroulent -->
        <ka-container
          code="container-22"
          :options="{
            click: page.container22Click,
            $state: { selected: $isEqual(page.$elements['question-6']?.style.hidden, page.$constants.question6Hidden) }
          }"
          :selected="{ click: page.container22ClickWhenSelected }">
          <!-- placement -->
          <ka-container code="container-23">
            <ka-icon
              code="icon-9"
              value="i-fa-solid:chart-line" />
            <ka-text code="suivi-de-la-formation">
              <h3 v-html="t('commentCaMarcheEntreprises.questionsDeroulent.container21.container22.container23.suiviDeLaFormation.value', `Suivi de la formation`)" />
            </ka-text>
          </ka-container>
          <ka-icon
            code="icone-developper-6"
            :options="{ $inheritState: { selected: true } }"
            value="i-fa-solid:angle-down" />
        </ka-container>
        <!-- Question 6 -->
        <ka-container
          code="question-6"
          :options="{
            animationIn: `fadeIn`,
            hidden: null
          }">
          <ka-text code="matchers-vous-accompagne">
            <span v-html="t('commentCaMarcheEntreprises.questionsDeroulent.container21.question6.matchersVousAccompagne.value', `Matchers vous accompagne tout au long de la formation et à l’issue de celle-ci pour vous décharger des contraintes administratives et veiller au bon déroulement de l’accompagnement.`)" />
          </ka-text>
        </ka-container>
      </ka-container>
    </ka-container>
    <!-- Pourquoi se former avec matchers ? -->
    <ka-container code="pourquoi-se-former-avec-matchers">
      <ka-text code="pourquoi-se-former">
        <h2 v-html="t('commentCaMarcheEntreprises.pourquoiSeFormerAvecMatchers.pourquoiSeFormer.value', `Pourquoi se former avec Matchers ? `)" />
      </ka-text>
      <!-- Conteneur -->
      <ka-container code="container-24">
        <!-- Bloc texte -->
        <ka-container code="bloc-texte">
          <!-- Placement -->
          <ka-container code="container-25">
            <ka-icon
              code="icon-10"
              value="i-fa-solid:lightbulb"
              inner />
          </ka-container>
          <ka-text code="un-genie-en-matiere">
            <h3 v-html="t('commentCaMarcheEntreprises.pourquoiSeFormerAvecMatchers.container24.blocTexte.unGenieEnMatiere.value', `Un génie en matière de financement de formation.`)" />
          </ka-text>
        </ka-container>
        <!-- Bloc texte -->
        <ka-container code="container-26">
          <!-- Placement -->
          <ka-container code="container-27">
            <ka-icon
              code="icon-11"
              value="i-fa-solid:hand-holding-heart"
              inner />
          </ka-container>
          <ka-text code="une-equipe-devouee">
            <h3 v-html="t('commentCaMarcheEntreprises.pourquoiSeFormerAvecMatchers.container24.container26.uneEquipeDevouee.value', `Une équipe dévouée toujours à votre écoute.`)" />
          </ka-text>
        </ka-container>
        <!-- Bloc texte -->
        <ka-container code="container-28">
          <!-- Conteneur -->
          <ka-container code="container-29">
            <ka-icon
              code="icon-12"
              value="i-fa-solid:certificate"
              inner />
          </ka-container>
          <ka-text code="le-modele-de-formation">
            <h3 v-html="t('commentCaMarcheEntreprises.pourquoiSeFormerAvecMatchers.container24.container28.leModeleDeFormation.value', `LE modèle de formation pratique par excellence.`)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Conteneur 1 -->
      <ka-container code="container-30">
        <ka-button
          code="prendre-rendez-vous"
          :options="{
            ripple: true,
            href: `https://meetings.hubspot.com/anne-pavard`,
            ariaLabel: `button`,
            click: page.prendreRendezVousClick,
            hidden: null
          }">
          <span v-html="t('commentCaMarcheEntreprises.pourquoiSeFormerAvecMatchers.container30.prendreRendezVous.value', `Prendre rendez-vous`)" />
        </ka-button>
      </ka-container>
    </ka-container>
    <ka-text code="contactez-nous">
      <span v-html="t('commentCaMarcheEntreprises.contactezNous.value', `Contactez nous !`)" />
    </ka-text>
    <!-- Formulaire -->
    <ka-container code="formulaire">
      <ka-iframe
        code="iframe"
        :options="{
          lazyOptions: {
            throttle: 200,
            once: true,
            intersection: { threshold: 0.1 }
          }
        }"
        value="https://share.hsforms.com/1f3xxGWPYQW6xBFgJ1nOV2Q2xvix" />
    </ka-container>
    <!-- Développer ses réseaux sociaux -->
    <ka-container code="developper-ses-reseaux-sociaux">
      <!-- Conteneur 1 -->
      <ka-container
        code="container-31"
        :options="{ hidden: null }">
        <!-- Conteneur 1 -->
        <ka-container code="container-32">
          <ka-image
            code="image-1"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/bb0a371c-3755-4cab-a689-4245c4d731cb/" />
        </ka-container>
        <!-- Conteneur 2 -->
        <ka-container code="container-33">
          <ka-text code="uses-cases">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container31.container33.usesCases.value', `Uses cases`)" />
          </ka-text>
          <ka-text code="developper-ses-reseaux">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container31.container33.developperSesReseaux.value', `Développer ses réseaux sociaux`)" />
          </ka-text>
          <ka-text code="eva-community-manager">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container31.container33.evaCommunityManager.value', `Eva, community manager pour un groupe d’hôtels du sud-ouest depuis 5 ans`)" />
          </ka-text>
          <ka-text code="isabelle-gerante-dun">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container31.container33.isabelleGeranteDun.value', `Isabelle, Gérante d’un hôtel indépendant près de Marseille.`)" />
          </ka-text>
          <ka-text code="lorem-ipsum-dolor-sit">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container31.container33.loremIpsumDolorSit.value', `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Conteneur 1 -->
      <ka-container
        code="container-34"
        :options="{ hidden: null }">
        <!-- Conteneur 1 -->
        <ka-container code="container-35">
          <ka-image
            code="image-2"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/bb0a371c-3755-4cab-a689-4245c4d731cb/" />
        </ka-container>
        <!-- Conteneur 2 -->
        <ka-container code="container-36">
          <ka-text code="text-1">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container34.container36.text1.value', `Uses cases`)" />
          </ka-text>
          <ka-text code="text-2">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container34.container36.text2.value', `Développer ses réseaux sociaux`)" />
          </ka-text>
          <ka-text code="text-3">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container34.container36.text3.value', `Eva, community manager pour un groupe d’hôtels du sud-ouest depuis 5 ans`)" />
          </ka-text>
          <ka-text code="text-4">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container34.container36.text4.value', `Isabelle, Gérante d’un hôtel indépendant près de Marseille.`)" />
          </ka-text>
          <ka-text code="text-5">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container34.container36.text5.value', `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Conteneur 1 -->
      <ka-container
        code="container-37"
        :options="{ hidden: null }">
        <!-- Conteneur 1 -->
        <ka-container code="container-38">
          <ka-image
            code="image-3"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/bb0a371c-3755-4cab-a689-4245c4d731cb/" />
        </ka-container>
        <!-- Conteneur 2 -->
        <ka-container code="container-39">
          <ka-text code="text-6">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container37.container39.text6.value', `Uses cases`)" />
          </ka-text>
          <ka-text code="text-7">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container37.container39.text7.value', `Développer ses réseaux sociaux`)" />
          </ka-text>
          <ka-text code="text-8">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container37.container39.text8.value', `Eva, community manager pour un groupe d’hôtels du sud-ouest depuis 5 ans`)" />
          </ka-text>
          <ka-text code="text-9">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container37.container39.text9.value', `Isabelle, Gérante d’un hôtel indépendant près de Marseille.`)" />
          </ka-text>
          <ka-text code="text-10">
            <span v-html="t('commentCaMarcheEntreprises.developperSesReseauxSociaux.container37.container39.text10.value', `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Bouttons slide -->
      <ka-container
        code="bouttons-slide"
        :options="{ hidden: null }">
        <!-- Conteneur 2 -->
        <ka-container code="container-40">
          <!-- Conteneur 3 -->
          <ka-container code="conteneur-3" />
        </ka-container>
        <!-- Conteneur 2 -->
        <ka-container code="container-41">
          <!-- Conteneur 3 -->
          <ka-container code="container-42" />
        </ka-container>
        <!-- Conteneur 2 -->
        <ka-container code="container-43">
          <!-- Conteneur 3 -->
          <ka-container code="container-44" />
        </ka-container>
      </ka-container>
    </ka-container>
    <!-- Conteneur -->
    <ka-container
      code="container-45"
      inner>
      <!-- Textes -->
      <ka-container code="textes">
        <ka-text code="vous-avez-des-questions">
          <span v-html="t('commentCaMarcheEntreprises.container45.textes.vousAvezDesQuestions.value', `Vous avez des questions ?`)" />
        </ka-text>
        <ka-text code="vous-voulez-parler">
          <span v-html="t('commentCaMarcheEntreprises.container45.textes.vousVoulezParler.value', `Vous voulez parler plan de formation ? Vous avez des questions sur notre fonctionnement ? Vous avez du mal à définir précisément votre besoin ?`)" />
        </ka-text>
      </ka-container>
      <!-- Boutons -->
      <ka-container
        code="boutons"
        :options="{ hidden: null }">
        <ka-button
          code="button-1"
          :options="{
            ripple: true,
            href: `https://www.matchers.fr/faq`,
            ariaLabel: `prendre rendez vous`,
            click: page.button1Click,
            hidden: null
          }">
          <span v-html="t('commentCaMarcheEntreprises.container45.boutons.button1.value', `Voir la F.A.Q`)" />
        </ka-button>
        <ka-button
          code="button-2"
          :options="{
            ripple: true,
            click: page.button2Click
          }">
          <span v-html="t('commentCaMarcheEntreprises.container45.boutons.button2.value', `Contactez-nous`)" />
        </ka-button>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { hubEntrepriseFonctionnement } from './store'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p7')
const appData = appDataStore()
const page = hubEntrepriseFonctionnement()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
